import { ILauncherVersionRestClient } from "./i-launcher-version-rest.client";
import { HttpClient } from "@angular/common/http";
import { HostUtil } from "../../../utils/host-util";
import { firstValueFrom, Observable } from "rxjs";
import { ARestClient, IPage, ISort } from "@zaeper/communication-lib";
import { Injectable } from "@angular/core";
import { ILauncherVersion } from "../../../models/application-version/i-launcher-version";
import { IGetLauncherVersionPageForm } from "./forms/i-get-launcher-version-page.form";

@Injectable()
export class LauncherVersionRestClient extends ARestClient implements ILauncherVersionRestClient {
  constructor( private readonly _httpClient: HttpClient ) {
    super();
  }

  getLauncherVersionPage(
    launcherId: string,
    getLauncherVersionPageForm: IGetLauncherVersionPageForm
  ): Promise<IPage<ILauncherVersion>> {
    const endpointUrl: string = super.getEndpointUrl( HostUtil.getApplicationApiEndpointUrl(), `v1/launcher/${ launcherId }/version/page` );

    const defaultSort: ISort = {
      field: "versionNumber",
      ascending: true
    };

    return firstValueFrom( this._httpClient.get( endpointUrl, {
      withCredentials: true,
      params: {
        pageNumber: getLauncherVersionPageForm.pageNumber,
        pageSize: getLauncherVersionPageForm.pageSize,
        sort: super.serializeSort( defaultSort )
      }
    } ) as Observable<IPage<ILauncherVersion>> );
  }
}
